<div [class.navigation-arrows]="navigationArrows" class="wrapper">
  <div
    data-at-month-datepicker-previous
    gtm="onChange"
    gtmAction="Previous Month"
    [gtmCategory]="gtmCategory"
    [class.arrow-disabled]="!canSelectPreviousMonth()"
    *ngIf="navigationArrows"
    (click)="onPreviousMonth()"
    class="arrow arrow-left"
  >
    <mat-icon>chevron_left</mat-icon>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>{{ '+GENERAL.DATEPICKER.MONTH_PICKER' | translate }}</mat-label>
    <input
      data-at-month-datepicker
      matInput
      readonly
      fieldTextContentTooltip
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="datepicker"
      [formControl]="datepickerDate"
    />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker
      #datepicker
      startView="year"
      (monthSelected)="onSelectMonth($event, datepicker)"
      panelClass="month-datepicker"
    >
    </mat-datepicker>
  </mat-form-field>
  <div
    data-at-month-datepicker-next
    gtm="onChange"
    gtmAction="Next Month"
    [gtmCategory]="gtmCategory"
    [class.arrow-disabled]="!canSelectNextMonth()"
    *ngIf="navigationArrows"
    (click)="onNextMonth()"
    class="arrow arrow-right"
  >
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
